import PropTypes from 'prop-types';
export default {
  layers: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  opacity: PropTypes.number.isRequired,
  tiled: PropTypes.bool.isRequired,
  srs: PropTypes.string.isRequired
};